import { render, staticRenderFns } from "./inviteList.vue?vue&type=template&id=564a6d39&scoped=true"
import script from "./inviteList.vue?vue&type=script&lang=js"
export * from "./inviteList.vue?vue&type=script&lang=js"
import style0 from "./inviteList.vue?vue&type=style&index=0&id=564a6d39&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564a6d39",
  null
  
)

export default component.exports